<template>
  <div class="full_page">
    <h1>One Order Only</h1>

    <div class="row">
      <div class="col-12">
        <table class="table table-striped table-bordered table-hover table-condensed">
          <thead>
          <tr>
            <th>Rank</th>
            <th>Customer Id</th>
            <th>Customer Name</th>
            <th>Qty Total</th>
            <th>Order Date</th>
            <th>Order Days Ago</th>
            <th>Sales Rep</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="customer in order_list_one_order" v-bind:key="customer.customer_id" :style="{color: line_color(customer.list_color), background: background_color(customer.has_to_pay)}">
            <td>{{customer.position}}</td>
            <td style="cursor: pointer; text-decoration: underline" v-on:click="show_customer_detail_page(customer.customer_id)">{{customer.customer_id}}</td>
            <td>{{customer.customer_display_name}}</td>
            <td>{{customer.total_qty_ordered}}</td>
            <td>{{customer.first_placed_order_date}}</td>
            <td>{{customer.days_since_last_order}}</td>
            <td>{{customer.sales_rep_display_name}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      order_list_one_order: 'admin/order_list_one_order',
    }),
  },
  mounted() {
    this.get_order_list();
  },
  methods: {
    line_color: function(list_color) {
      if(list_color === 2) {
        return '#ff0000';
      }
      return '#000000';
    },
    background_color: function(background_color) {
      if(background_color === 1) {
        return '#FFFF00';
      }
      return null;
    },
    get_order_list () {
      if(this.order_list_one_order.length === 0)
      {
        this.$store.dispatch('admin/getOrdersListOneOrder');
      }
    },
    show_customer_detail_page(customer_id) {
      this.$router.push({name: "customer_details", 'params':{customer_id: customer_id} });
    },

  }
}
</script>

<style scoped>

.full_page {
  margin-left: 20px;
  margin-right: 20px;
}

</style>
